
import {
  computed, defineComponent, ref, toRefs,
} from 'vue';
import { round } from 'lodash-es';
import { format as formatCurrency } from '@/lib/currency';

import Input from './Input.vue';

export default defineComponent({
  name: 'CurrencyInput',
  props: {
    label: String,
    modelValue: {
      required: true,
    },
  },
  components: { Input },
  methods: {
    checkKeypress(event: KeyboardEvent) {
      const keyCode = event.keyCode ? event.keyCode : event.which;
      // 0xD = enter
      // 0x2c = ,
      // 0x2e = .
      // 0x30 = 0
      // 0x39 = 9
      if (
        keyCode !== 0xd
          && keyCode !== 0x2c
          && keyCode !== 0x2e
          && (keyCode < 0x30 || keyCode > 0x39)
      ) {
        event.preventDefault();
      }
    },
  },
  setup(props, { emit }) {
    const { modelValue } = toRefs(props);
    const editing = ref(false);

    const innerValue = computed({
      get() {
        if (editing.value) {
          return modelValue.value;
        }
        if (modelValue.value === null) {
          return '€';
        }

        return formatCurrency(Number(modelValue.value));
      },
      set(value) {
        // Clean the number to prevent accidentals and get as close as possible to the expected number
        const cleanValue = String(value)
        // Normalize commas to periods
          .replace(/,/g, '.')
        // Remove all non-digits or periods
          .replace(/[^\d.]/g, '')
        // Remove all periods after the first
        //   First replace the first period with a placeholder
          .replace('.', '[[[[[PERIOD_PLACEHOLDER]]]]]')
        //   Then remove all periods
          .replace(/\./g, '')
        //   And return the placeholder to normal
          .replace('[[[[[PERIOD_PLACEHOLDER]]]]]', '.');

        // Round to 2 decimals
        emit('update:modelValue', round(Number(cleanValue), 2));
      },
    });

    return {
      editing,
      innerValue,
    };
  },
});
